import APIv4GetProductByIdResponseAdapter from './APIv4GetProductByIdResponseAdapter';
const APIv4GetProductsResponseAdapter = {
  toProductList: (response, colorMetaproducts = {}) => {
    const {
      response_data
    } = response;
    return response_data.objects.map(productInfo => APIv4GetProductByIdResponseAdapter.getProductInfo(productInfo, colorMetaproducts));
  }
};
export default APIv4GetProductsResponseAdapter;
